module.exports = __webpack_public_path__ + "static/media/speaker-edwin.c5494132.jpg";